module.exports = __webpack_public_path__ + "static/media/Living.cecde23f.webp";